import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { handleDealApplicationDrawer, updateDealApplicationData } from '../../../store/investor/action';
import { useEffect, useState } from 'react';
import { DEAL, DealFilters, MANDATE } from '../../../store/investor/reducer';
import { fetchDataByConfig } from '../../ManageDealDrawer/ManageDealDrawerService';
import { fetchAllAvailableProducts } from '../../../store/investor/apiHelpers';
import { DEAL_VIEW_TYPES } from '../../../store/investor/constants';
import { useLocation, useSearchParams } from 'react-router-dom';
import { updateQueryParams } from '../../../utils/searchParamUtils';

const useDealApplicationDrawerLogic = (setTempFilters: (filters: DealFilters) => void) => {
    const dispatch = useAppDispatch();
    const [params, setParams] = useSearchParams();
    const location = useLocation();
    const userData = useAppSelector((state) => state.user.userData);
    const owners = useAppSelector((state) => state.investor.ownerDropdownOptions).map((owner) => ({
        value: owner.userId,
        label: owner.name,
    }));
    const dealFilters = useAppSelector((state) => state.investor.dealFilters);
    const dealSatusConfig = useAppSelector((state) => state.investor.deals.dealStatusConfig);
    const [lenders, setLenders] = useState<any[]>([]);
    const [products, setProducts] = useState<{ value: string; label: string }[]>([]);
    const selectedCategory = params.get('category') || DEAL_VIEW_TYPES.DEAL_VIEW;

    const dropdownOptions =
        selectedCategory === DEAL_VIEW_TYPES.DEAL_VIEW ? dealSatusConfig?.[DEAL] || [] : dealSatusConfig?.[MANDATE] || [];

    const optionsMap = {
        dealReceivers: lenders,
        statuses: Object.values(dropdownOptions).map((status) => ({
            value: status.value,
            label: status.label,
        })),
        dealOwners: owners,
        uwAnalysts: owners,
        dcmOwners: owners,
        leadOwners: owners,
        products: products,
    };

    useEffect(() => {
        fetchLenders();
        if (userData?.investorOrgId) {
            fetchProducts();
        }
    }, [userData?.investorOrgId]);

    const fetchLenders = async () => {
        try {
            if (userData?.investorOrgId) {
                const response = await fetchDataByConfig(
                    {
                        parentOrgId: userData.investorOrgId,
                    },
                    'GET_ALL_LENDERS',
                    'GET',
                );

                if (response?.data?.lenderMap?.ADMIN) {
                    const res = response.data.lenderMap?.ADMIN;
                    const options = Object.keys(res).map((option: any) => ({
                        label: res[option],
                        value: option,
                    }));
                    setLenders(options);
                }
            }
        } catch (error) {
            console.error('Error fetching lenders:', error);
        }
    };

    const fetchProducts = async () => {
        try {
            let payload: any = {
                aggregatorId: userData?.investorOrgId,
            };
            const response = await fetchAllAvailableProducts(payload, true);

            if (response) {
                const options = Object.values(response).map((item: any) => ({
                    value: item.productId,
                    label: item.productName,
                }));

                setProducts(options);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const closeDrawer = () => {
        setTempFilters(dealFilters);
        if (params.has('dealStatus')) {
            params.delete('dealStatus');
            updateQueryParams(params, setParams, {}, location);
        }
        dispatch(
            handleDealApplicationDrawer({
                open: false,
                width: '0',
                source: '',
                dealId: '',
                heading: '',
                subHeading: '',
            }),
        );
        dispatch(
            updateDealApplicationData({
                masterData: {
                    dealTerms: {},
                    products: [],
                    dealReceiverDetailMap: new Map(),
                },
            }),
        );
    };

    return {
        closeDrawer,
        owners,
        optionsMap,
    };
};

export default useDealApplicationDrawerLogic;
